import { inject, Injectable } from '@angular/core';
import { SharedLanguageService } from '@language';
import { Observable } from 'rxjs';
import { ApiJob } from '../core/jobs/entities/api-job.entity';
import { RecordJobsDataService } from '../core/records/data-services/record-jobs.data-service';
import { RecordId } from '../core/records/entities/metadata/metadata.entity';

@Injectable()
export class ProcessingProgressSandbox {
    readonly #recordJobsDataService: RecordJobsDataService = inject(RecordJobsDataService);
    readonly #translateService: SharedLanguageService = inject(SharedLanguageService);

    getRecordJobs(recordId: RecordId): Observable<ApiJob[]> {
        return this.#recordJobsDataService.getRecordJobs(recordId);
    }

    translate(key: string): string {
        return this.#translateService.translate(key);
    }
}
